import showdown from 'showdown';
import React from 'react';
import PostBody from './post-body';

const MarkDownContent = ({ md, listItemIconURI }) => {
  const converter = new showdown.Converter();
  const html = converter.makeHtml(md);
  let result = html;

  if (html != null) {
    const videos = html.match(/(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g);
    const images = html.match(/(?:<img[^>]*)(?:(?:\/>)|(?:>.*?<\/img>))/g);

    // In order for images + videos to appear correctly at every screen size, they require wrappers
    if (videos != null) {
      videos.forEach(match => {
        result = result.replace(
          match,
          `<div class = "video-root"><div class = "video-wrapper">${match}</div></div>`
        );
      });
    }

    if (images != null) {
      images.forEach(match => {
        result = result.replace(match, `<div class = "image-wrapper">${match}</div>`);
      });
    }
  }
  const postHTML = { __html: result };
  return <PostBody dangerouslySetInnerHTML={postHTML} listItemIconURI={listItemIconURI} />;
};

export default MarkDownContent;
